// extracted by mini-css-extract-plugin
export default {"change-header-pic-box":"index_change-header-pic-box__jiuXI"};